import { FC, useMemo } from 'react';

import { Tag, VSpacing } from '@hh.ru/magritte-ui';

import { useModerationListPolling } from 'hooks/moderation/useModerationListPolling';
import useTrls from 'hooks/translation/useTrls';

import { CampaignModeration } from 'components/Admin/ModerationList/CampaignModeration/CampaignModeration';

import { useSelector } from 'store/utils';

const TrlKeys = {
    count: 'admin.moderationList.count',
};

export const ModerationList: FC = () => {
    const campaignModerationList = useSelector((state) => state.moderation.campaignModerationList);

    useModerationListPolling();
    const trls = useTrls();

    const totalBannersCount = useMemo(
        () => campaignModerationList.reduce((total, campaign) => total + campaign.banners.length, 0),
        [campaignModerationList]
    );

    return (
        <>
            <VSpacing default={32} />
            <Tag style="neutral" size="large">
                {trls(TrlKeys.count, [totalBannersCount])}
            </Tag>
            <VSpacing default={48} />
            {campaignModerationList.map((campaign) => (
                <CampaignModeration key={campaign.campaignId} campaign={campaign} />
            ))}
        </>
    );
};
